import "./MarketMoversWidgetComponent.scss";
import template from "./MarketMoversWidgetComponent.html";
import {IComponentOptions} from "angular";
import {ComponentCallback} from "../../../../../types/AngularJS";
import {MarketMoverModel} from "../../../../../market/movers/models/MarketMoversStateModel";
import {ObjectUtil} from "../../../../../js/util/ObjectUtil";
import {WidgetDisplayMode} from "../../../models/WidgetDisplayMode";
import {ReplaySubject} from "rxjs";

export const MarketMoversWidget = "tfMarketMoversWidget";

export function marketMoversWidget(): IComponentOptions {
    return {
        template,
        bindings: {
            displayMode: "<",
            onSecurityChanged: "&"
        },
        controllerAs: "ctrl",
        controller: MarketMoversWidgetComponentController
    };
}

export class MarketMoversWidgetComponentController {

    /** @input */
    public set displayMode(displayMode: WidgetDisplayMode | null) {
        if (displayMode != null) {
            this.displayMode$.next(displayMode);
        }
    }

    private readonly displayMode$ = new ReplaySubject<WidgetDisplayMode>(1);

    /** @output */
    public readonly onSecurityChanged: ComponentCallback;

    public moverClicked(mover: MarketMoverModel) {
        const security = ObjectUtil.pick(mover, "code", "exchange");
        this.onSecurityChanged({security});
    }
}
